/**
 * Cart Drawer – Relaunch (snippets/cart-drawer-relaunch.liquid)
 *
 * Zuständig nur für den Upsell-Button „Wird oft hinzugefügt“ und dessen Tracking. Mengenänderung, Entfernen,
 * Öffnen/Schließen und das Re-Rendern übernimmt weiterhin Prestiges CartSection (theme.js). Nach erfolgreichem
 * Add wird "product:added" auf document gefeuert – darauf hört CartSection und lädt den Drawer neu.
 *
 * Tracking (Custom Pixel, siehe DOKUMENTATION-TRACKING-CUSTOM-PIXEL.md, Abschnitt „Upsell-Tracking“):
 *   view_item_list_c        – Cross-Sell sichtbar (pro Öffnen des Drawers und pro neuem Produkt-Set)
 *   add_to_cart_context_c   – vor dem Add; der Pixel hängt die Herkunft an Shopifys add_to_cart
 */
(function () {
  'use strict';

  var SELECTOR = '[data-action="cart-upsell-add"]';
  var DRAWER_ID = 'sidebar-cart';
  var LIST_ID = 'cart_drawer_crosssell';
  var LIST_NAME = 'Cart Drawer Cross-Sell';

  /* --------------------------------------------------------------- Tracking */

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name + '_c', data);
      }
    } catch (e) { /* Tracking darf den Drawer nie stören */ }
  }

  /** GA4-Item aus den data-Attributen des Upsell-Buttons (Preis in Cent). */
  function itemFromButton(button, index) {
    return {
      item_id: button.getAttribute('data-product-id') || '',
      item_name: button.getAttribute('data-product-title') || '',
      item_brand: button.getAttribute('data-vendor') || '',
      item_category: button.getAttribute('data-type') || '',
      price: (parseInt(button.getAttribute('data-price'), 10) || 0) / 100,
      item_variant: button.getAttribute('data-variant-title') || 'Default Title',
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME,
      index: index
    };
  }

  /**
   * view_item_list, sobald der Drawer offen ist und Cross-Sell-Produkte zeigt.
   * #sidebar-cart bleibt über alle Re-Renders bestehen (Prestige tauscht nur ".Cart"), deshalb reicht ein
   * MutationObserver darauf: aria-hidden für Öffnen/Schließen, childList für Re-Renders.
   * Dedupe über die Varianten-IDs: gleiches Set im selben Öffnungsvorgang zählt nur einmal; Schließen oder ein
   * Verschwinden des Blocks setzt zurück, ein anderes Set zählt neu.
   */
  function initImpressionTracking() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer || !('MutationObserver' in window)) { return; }

    var lastKey = null;
    var timer = null;

    function check() {
      if (drawer.getAttribute('aria-hidden') !== 'false') { lastKey = null; return; }

      var buttons = drawer.querySelectorAll(SELECTOR);
      if (!buttons.length) { lastKey = null; return; }

      var key = Array.prototype.map.call(buttons, function (b) { return b.getAttribute('data-variant-id'); }).join(',');
      if (key === lastKey) { return; }
      lastKey = key;

      publish('view_item_list', {
        item_list_id: LIST_ID,
        item_list_name: LIST_NAME,
        items: Array.prototype.map.call(buttons, itemFromButton)
      });
    }

    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(check, 100);
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });
    check();
  }

  /* --------------------------------------------------------------- Add */

  function showError(button, message) {
    var drawer = button.closest('#' + DRAWER_ID);
    var box = drawer && drawer.querySelector('[data-cd-error]');
    if (!box) { return; }
    box.textContent = message;
    box.hidden = false;
    clearTimeout(box._cdTimer);
    box._cdTimer = setTimeout(function () { box.hidden = true; }, 4000);
  }

  function setLoading(button, loading) {
    button.classList.toggle('is-loading', loading);
    if (loading) { button.setAttribute('disabled', 'disabled'); } else { button.removeAttribute('disabled'); }
    document.dispatchEvent(new CustomEvent(loading ? 'theme:loading:start' : 'theme:loading:end'));
  }

  function addToCart(button) {
    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) { return; }

    var routes = window.routes || {};
    var addUrl = (routes.cartAddUrl || '/cart/add') + '.js';
    var errorText = (window.languages && window.languages.cartUpsellError) || 'Konnte nicht hinzugefügt werden.';

    // Herkunft für den Custom Pixel: er hängt sie an Shopifys Standard-Event product_added_to_cart (→ add_to_cart)
    publish('add_to_cart_context', {
      variant_id: String(variantId),
      quantity: 1,
      source: LIST_ID,
      item_list_id: LIST_ID,
      item_list_name: LIST_NAME
    });

    setLoading(button, true);

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (response) {
      return response.json().then(function (data) { return { ok: response.ok, data: data }; });
    }).then(function (result) {
      if (!result.ok) {
        setLoading(button, false);
        showError(button, (result.data && (result.data.description || result.data.message)) || errorText);
        return;
      }

      // CartSection (theme.js) re-rendert den Drawer; der Button wird dabei mit ersetzt.
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { variant: { id: variantId }, quantity: 1 }
      }));
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }).catch(function () {
      setLoading(button, false);
      showError(button, errorText);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!button) { return; }
    event.preventDefault();
    addToCart(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImpressionTracking);
  } else {
    initImpressionTracking();
  }
})();
